/**
 * Convert UTC time to local time.
 * Takes HH:MM in UTC and converts to HH:MM in user's browser timezone.
 *
 * @param timeString - HH:MM format in UTC (e.g., "14:00")
 * @returns HH:MM in browser's local timezone
 */
export function convertUTCToLocalTime(timeString: string): string {
  const [hours, minutes] = timeString.split(':').map(Number);
  const utcDate = new Date();
  utcDate.setUTCHours(hours, minutes, 0, 0);
  const localHours = utcDate.getHours().toString().padStart(2, '0');
  const localMinutes = utcDate.getMinutes().toString().padStart(2, '0');
  return `${localHours}:${localMinutes}`;
}

/**
 * Convert local time to UTC time.
 * Takes HH:MM in user's browser timezone and converts to HH:MM in UTC.
 *
 * @param timeString - HH:MM in local timezone
 * @returns HH:MM in UTC
 */
export function convertLocalTimeToUTC(timeString: string): string {
  const [hours, minutes] = timeString.split(':').map(Number);
  const localDate = new Date();
  localDate.setHours(hours, minutes, 0, 0);
  const utcHours = localDate.getUTCHours().toString().padStart(2, '0');
  const utcMinutes = localDate.getUTCMinutes().toString().padStart(2, '0');
  return `${utcHours}:${utcMinutes}`;
}

/**
 * Get user's timezone abbreviation for display (e.g., "EST", "PST", "GMT").
 *
 * @returns Timezone abbreviation or 'Local' if unavailable
 */
export function getTimezoneAbbreviation(): string {
  const short = new Intl.DateTimeFormat('en-GB', {
    timeZoneName: 'short',
  })
    .formatToParts(new Date())
    .find((part) => part.type === 'timeZoneName')?.value;
  return short || 'Local';
}
